<template>
    <div>
        <!-- Quicklinks -->
        <sau-dashboard-common-links class="mb-4" :colo-services="coloServices"></sau-dashboard-common-links>

        <div class="row" v-if="hasPermission('products')">
            <div class="col my-4">
                <h4>Active Services</h4>
                <sau-dashboard-services></sau-dashboard-services>
            </div>
        </div>

        <div class="row">
            <div class="col mb-4">
                <div class="bg-blue-100 border-l-4 border-blue-500 text-blue-700 px-4 py-3" role="alert">
                    <p class="sau-font sm mb-0">You can subscribe to incident notifications and stay up to date about planned maintenance at <a href="https://status.mysau.com.au" target="_blank" title="View our current status">https://status.mysau.com.au</a></p>
                </div>
            </div>
        </div>

        <div v-if="showSingleMethodAlert" class="row">
            <div class="col mb-4">
                <div class="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 px-4 py-3" role="alert">
                    <p class="sau-font sm mb-0">You have only one two-factor authentication method on your account. We recommend enabling additional methods to avoid losing access. You can update your authentication methods on your <a href="/account/security">account security page</a>.</p>
                </div>
            </div>
        </div>

        <!-- Suspended services with overdue invoices -->
        <template v-if="activeUserHasPermission('invoices') && hasPermission('products')">
            <!-- Show spinner when loading -->
            <template v-if="loading">
                <div class="sau-bx bx-pad text-center mb-4">
                    <sau-spinner />
                </div>
            </template>

            <!-- Dashboard -->
            <template v-else-if="overdueServices && overdueServices.length">
                <div class="mb-4 drop">
                    <div class="h-100">
                        <h4>Suspended Services</h4>
                        <sau-dashboard-overdue-services />
                    </div>
                </div>
            </template>
        </template>

        <!-- Invoices Expiring domains, common links -->
        <div class="row">
            <div
                v-if="activeUserHasPermission('invoices')"
                class="col-sm-12 drop"
                :class="[areDomainsToBeShown() ? 'col-lg-7' : 'col-lg-12']"
            >
                <div class="h-100">
                    <h4>Recent Invoices</h4>
                    <sau-dashboard-invoices :invoices="objInvoices"></sau-dashboard-invoices>
                </div>
            </div>

            <div
                v-if="areDomainsToBeShown()"
                class="col-sm-12 col-lg-5 drop"
            >
                <div class="h-100">
                    <h4>Expiring Domains/SSL’s</h4>
                    <sau-dashboard-domains :domains="objDomains"></sau-dashboard-domains>
                </div>
            </div>
        </div>

        <div class="row pt-6">
            <div class="col">
                <h4>Knowledge Base &amp; 24/7 Support</h4>
                <sau-dashboard-learn-more></sau-dashboard-learn-more>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import Domains from './_Domains';
import Services from './_Services';
import LearnMore from './_LearnMore';
import CommonLinks from './_CommonLinks';
import Invoices from './_Invoices';
import SauDashboardOverdueServices from './_OverdueServices';
export default {
    props:[
        'invoices',
        'domains',
        'subscribedToStatusAlerts',
        'coloServices'
    ],
    data() {
        return {
			objInvoices: '',
			objDomains: '',
        }
    },
    components:{
        'sau-dashboard-domains': Domains,
        'sau-dashboard-common-links': CommonLinks,
        'sau-dashboard-services': Services,
        'sau-dashboard-learn-more': LearnMore,
        'sau-dashboard-invoices': Invoices,
        'sau-dashboard-overdue-services': SauDashboardOverdueServices
    },
    created(){
        this.objInvoices = JSON.parse(this.invoices);
        this.objDomains = JSON.parse(this.domains);
        this.$store.dispatch('getOverdueServices');
    },
    computed:{
        ...mapState([
            'userHasVerified',
            'overdueServices',
            'loadingStates'
        ]),
        loading() {
            return this.loadingStates.overdueServices;
        },
        showSingleMethodAlert() {
            let keys = ['two_factor_mobile', 'google2fa_secret'];
            let enabledAlternateMethods = this.userDetails ? 
                keys.filter(key => this.userDetails[key]): 
                [];
            return this.userDetails && enabledAlternateMethods.length === 0;
        },
    },
    methods: {
        userIsActive: function () {
            return this.userHasVerified
                && this.userHasVerified.isActive;
        },
        activeUserHasPermission: function (permission) {
            return this.userIsActive()
                && this.hasPermission(permission);
        },
        areDomainsToBeShown: function () {
            return this.objDomains.length
                && this.activeUserHasPermission('domains');
        },
    }
}
</script>
